var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","color":"primary","dark":""}},[_c('v-col',{staticClass:"text-start",attrs:{"cols":"12"}},[_vm._v(" © 2018 - "+_vm._s(new Date().getFullYear())+" Global Psytech Sdn. Bhd. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }